import _createClass from "/home/runner/work/greenlight/greenlight/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/home/runner/work/greenlight/greenlight/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _inherits from "/home/runner/work/greenlight/greenlight/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/greenlight/greenlight/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/greenlight/greenlight/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _wrapNativeSuper from "/home/runner/work/greenlight/greenlight/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
// these aren't really private, but nor are they really useful to document
/**
 * @private
 */
var LuxonError = /*#__PURE__*/function (_Error) {
  _inherits(LuxonError, _Error);
  var _super = _createSuper(LuxonError);
  function LuxonError() {
    _classCallCheck(this, LuxonError);
    return _super.apply(this, arguments);
  }
  return _createClass(LuxonError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * @private
 */
export var InvalidDateTimeError = /*#__PURE__*/function (_LuxonError) {
  _inherits(InvalidDateTimeError, _LuxonError);
  var _super2 = _createSuper(InvalidDateTimeError);
  function InvalidDateTimeError(reason) {
    _classCallCheck(this, InvalidDateTimeError);
    return _super2.call(this, "Invalid DateTime: ".concat(reason.toMessage()));
  }
  return _createClass(InvalidDateTimeError);
}(LuxonError);

/**
 * @private
 */
export var InvalidIntervalError = /*#__PURE__*/function (_LuxonError2) {
  _inherits(InvalidIntervalError, _LuxonError2);
  var _super3 = _createSuper(InvalidIntervalError);
  function InvalidIntervalError(reason) {
    _classCallCheck(this, InvalidIntervalError);
    return _super3.call(this, "Invalid Interval: ".concat(reason.toMessage()));
  }
  return _createClass(InvalidIntervalError);
}(LuxonError);

/**
 * @private
 */
export var InvalidDurationError = /*#__PURE__*/function (_LuxonError3) {
  _inherits(InvalidDurationError, _LuxonError3);
  var _super4 = _createSuper(InvalidDurationError);
  function InvalidDurationError(reason) {
    _classCallCheck(this, InvalidDurationError);
    return _super4.call(this, "Invalid Duration: ".concat(reason.toMessage()));
  }
  return _createClass(InvalidDurationError);
}(LuxonError);

/**
 * @private
 */
export var ConflictingSpecificationError = /*#__PURE__*/function (_LuxonError4) {
  _inherits(ConflictingSpecificationError, _LuxonError4);
  var _super5 = _createSuper(ConflictingSpecificationError);
  function ConflictingSpecificationError() {
    _classCallCheck(this, ConflictingSpecificationError);
    return _super5.apply(this, arguments);
  }
  return _createClass(ConflictingSpecificationError);
}(LuxonError);

/**
 * @private
 */
export var InvalidUnitError = /*#__PURE__*/function (_LuxonError5) {
  _inherits(InvalidUnitError, _LuxonError5);
  var _super6 = _createSuper(InvalidUnitError);
  function InvalidUnitError(unit) {
    _classCallCheck(this, InvalidUnitError);
    return _super6.call(this, "Invalid unit ".concat(unit));
  }
  return _createClass(InvalidUnitError);
}(LuxonError);

/**
 * @private
 */
export var InvalidArgumentError = /*#__PURE__*/function (_LuxonError6) {
  _inherits(InvalidArgumentError, _LuxonError6);
  var _super7 = _createSuper(InvalidArgumentError);
  function InvalidArgumentError() {
    _classCallCheck(this, InvalidArgumentError);
    return _super7.apply(this, arguments);
  }
  return _createClass(InvalidArgumentError);
}(LuxonError);

/**
 * @private
 */
export var ZoneIsAbstractError = /*#__PURE__*/function (_LuxonError7) {
  _inherits(ZoneIsAbstractError, _LuxonError7);
  var _super8 = _createSuper(ZoneIsAbstractError);
  function ZoneIsAbstractError() {
    _classCallCheck(this, ZoneIsAbstractError);
    return _super8.call(this, "Zone is an abstract class");
  }
  return _createClass(ZoneIsAbstractError);
}(LuxonError);